import { inject } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { lastValueFrom } from 'rxjs';
import { CartItem, Category } from '@softapps/wws/pos-core';
import {
  SOFTLINE_API_SELF_CHECKOUT_TOUCH_CATEGORIES,
  SOFTLINE_API_SELF_CHECKOUT_TOUCH_CATEGORY_IMAGE,
  SOFTLINE_API_SELF_CHECKOUT_TOUCH_CATEGORY_PRODUCTS,
  SOFTLINE_API_SELF_CHECKOUT_TOUCH_PRODUCT_IMAGE,
} from '../self-checkout.api';

export class ProductRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async loadCategories(returnable = false): Promise<Category[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_SELF_CHECKOUT_TOUCH_CATEGORIES,
      queryParams: { returnable },
    });
  }

  async loadCategoryImageById(categoryId: number): Promise<string> {
    const result = await lastValueFrom(
      this.#dataAccess.download({
        path: SOFTLINE_API_SELF_CHECKOUT_TOUCH_CATEGORY_IMAGE,
        pathParams: { categoryId },
      })
    );

    if (result && result.type === 'response' && result.response) {
      return URL.createObjectURL(
        result.response instanceof Blob ? result.response : new Blob([result.response])
      );
    }

    return '';
  }

  async loadProductsByCategoryId(
    categoryId: number,
  ): Promise<CartItem[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_SELF_CHECKOUT_TOUCH_CATEGORY_PRODUCTS,
      pathParams: { categoryId },
    });
  }

  async loadProductImageById(productId: number): Promise<string> {
    const result = await lastValueFrom(
      this.#dataAccess.download({
        path: SOFTLINE_API_SELF_CHECKOUT_TOUCH_PRODUCT_IMAGE,
        pathParams: { productId },
      })
    );

    if (result && result.type === 'response' && result.response) {
      return URL.createObjectURL(
        result.response instanceof Blob ? result.response : new Blob([result.response])
      );
    }

    return '';
  }
}
